import axios from 'axios';
import { LocaleCode } from '../types/locale';
import Post from '../types/post';
import { RecentPostsResponse } from '../types/recentPost';

export async function incrementPostViewsApi(localeCode: LocaleCode, postId: Post['id']) {
  const { data } = await axios.patch<RecentPostsResponse>(`/api/posts/${localeCode}/${postId}/views`);
  return data;
}
